const commonInit = {
  searchTime: '',
  trendingStatus: '',
};

export default {
  namespace: 'searchModels',
  state: commonInit,
  reducers: {
    save(state: any, { payload }) {
      return { ...state, ...payload };
    },
    setSearchTime(state: any, { payload }) {
      return {
        ...state,
        searchTime: payload,
      };
    },
    setTrendingStatus(state: any, { payload }) {
      return {
        ...state,
        trendingStatus: payload,
      };
    },
  },
  effects: {},
};
